// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AutoCompleteResultRow-cls1__c836d7125c5bf5e0f861{/*!*/}.AutoCompleteResultRow-cls2___639e41f9f5b52880ad8{border-radius:3px;width:30px;height:30px;margin-right:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AutoCompleteResultRow-cls1__c836d7125c5bf5e0f861",
	"cls2": "AutoCompleteResultRow-cls2___639e41f9f5b52880ad8 AutoCompleteResultRow-cls1__c836d7125c5bf5e0f861"
};
export default ___CSS_LOADER_EXPORT___;
